module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-2.b4ee56ec.jpg";